// grinders.js

export const grinders = [
  // Baratza
  "Baratza Encore",
  "Baratza Encore ESP",
  "Baratza Virtuoso+",
  "Baratza Sette 30",
  "Baratza Sette 270",
  "Baratza Sette 270Wi",
  "Baratza Forté BG",
  "Baratza Forté AP",

  // Fellow
  "Fellow Ode Gen 1",
  "Fellow Ode Gen 2",

  // Breville
  "Breville Smart Grinder Pro",
  "Breville Dose Control Pro",

  // Eureka
  "Eureka Mignon Manuale",
  "Eureka Mignon Silenzio",
  "Eureka Mignon Specialita",
  "Eureka Mignon Notte",
  "Eureka Mignon Zero",
  "Eureka Atom 65",
  "Eureka Atom 75",

  // 1Zpresso
  "1Zpresso ZP6 Special",
  "1Zpresso ZP6 2nd Gen",
  "1Zpresso JX",
  "1Zpresso JX-Pro",
  "1Zpresso J-Max",
  "1Zpresso K-Max",
  "1Zpresso X-Pro S",
  "1Zpresso Q2 S",

  // Niche
  "Niche Zero",
  "Niche Duo",

  // Timemore
  "Timemore Sculptor 078",
  "Timemore Sculptor 064",
  "Timemore Chestnut E",
  "Timemore Chestnut C2",
  "Timemore Chestnut G1",
  "Timemore Chestnut Slim",
  "Timemore Chestnut Nano",

  // DF (G-iota)
  "DF64 (G-iota)",
  "DF83",
  "DF54",

  // Rancilio
  "Rancilio Rocky Doser",
  "Rancilio Rocky Doserless",

  // Wilfa
  "Wilfa Svart Aroma",
  "Wilfa Uniform Grinder",

  // Comandante
  "Comandante C40 MK4",
  "Comandante C40 Nitro Blade MK3",
  "Comandante C40 MK4 Trailmaster",

  // Kinu
  "Kinu M47 Classic",
  "Kinu M47 Phoenix",
  "Kinu M47 Simplicity",
  "Kinu M47 Traveller",

  // Knock
  "Knock Aergrind",
  "Knock Aergrind V2",
  "Knock Feldgrind",

  // Normcore
  "Normcore V2 Manual Grinder",

  // Porlex
  "Porlex Mini",

  // Hario
  "Hario Skerton Pro",
  "Hario Mini Slim Pro",

  // Kingrinder
  "Kingrinder K6",
  "Kingrinder Electric X1",

  // Varia
  "Varia VS3 Manual",

  // BPlus
  "BPlus Apollo",

  // LWW
  "LWW HG-1",

  // Helor
  "Helor 101",

  // Ceado
  "Ceado E37S",
  "Ceado E5P",

  // Mazzer
  "Mazzer Mini",
  "Mazzer Mini Electronic",
  "Mazzer Super Jolly",

  // La Marzocco
  "La Marzocco Lux D",

  // Fiorenzato
  "Fiorenzato F4 Nano",
  "Fiorenzato F64 Evo",

  // Compak
  "Compak E8",

  // Anfim
  "Anfim Best On Demand",

  // Lelit
  "Lelit Fred PL043MMI",
  "Lelit William PL72",

  // Molar
  "Molar X",

  // Mahlkönig
  "Mahlkönig X54 Home",
  "Mahlkönig Guatemala",
  "Mahlkönig Vario Home",

  // Option-O
  "Option-O Lagom P64",
  "Option-O Lagom Mini"
];